module.exports = ['$scope', '$http', function($scope, $http) {
    $scope.testclick = function() {
        alert('worked uh huh2');
    }
    $scope.medelaClick = function(isHref) {
        this.closeModal();
       /* if (isHref) {
            // coremetrics.elementTag('', 'Member: Wellness');
            window.open("http://www.medeladelivers.com/");
        }*/
    }
    $scope.redirectHome = function(){
        location.replace("/member/home/");
    }
}];

